import swal from "sweetalert2";

function checkRpeAndRole(companyRpes, companyRoles) {
  const atLeastOneRpeAndOneRole = companyRpes.length && companyRoles.length;

  if (this.model.isTrainee && !atLeastOneRpeAndOneRole) {
    swal({
      title: "Validation Error",
      text: "Must have at least one RPE and one Role",
      type: "error",
      confirmButtonClass: "btn ml-xs btn-info btn-fill",
      confirmButtonText: "Ok",
      buttonsStyling: false
    });

    return false;
  }

  return true;
}

export default checkRpeAndRole;
